"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _Flex = _interopRequireDefault(require("../../../../../Flex"));

var _Skeleton = _interopRequireDefault(require("../../../../../Skeleton"));

var _Text = _interopRequireDefault(require("../../../../../Text"));

var _useTheme2 = _interopRequireDefault(require("../../../../../styles/useTheme"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var skeletons = [null, null];

var Loading = function Loading(props) {
  var _useTheme = (0, _useTheme2["default"])(),
      spacing = _useTheme.spacing;

  return (0, _core.jsx)(_react["default"].Fragment, null, skeletons.map(function (_, index) {
    return (0, _core.jsx)(_Flex["default"], (0, _extends2["default"])({
      key: index
    }, props), (0, _core.jsx)(_Text["default"], null, (0, _core.jsx)(_Skeleton["default"], {
      width: spacing(10)
    })));
  }));
};

__signature__(Loading, "useTheme{{ spacing }}", function () {
  return [_useTheme2["default"]];
});

var _default = Loading;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(skeletons, "skeletons", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Hours/HourlyCycle/WeekdayHours/Hours/Loading.tsx");
  reactHotLoader.register(Loading, "Loading", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Hours/HourlyCycle/WeekdayHours/Hours/Loading.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Hours/HourlyCycle/WeekdayHours/Hours/Loading.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();